query CanReview(
    $slug: String!
) {
    canReview(slug: $slug) {
        status
        message
    }
    video(slug: $slug) {
        status
    }
}
